import _merge from 'lodash/merge';
import _cloneDeep from 'lodash/cloneDeep';
import i18next from 'i18next';
import { i18nLangOfGame } from 'locale/i18n';
import { gameTypes } from 'config/promoGameTypes';
import {
    system050,
    system200,
    system900,
    promo100,
    promo500,
    zines500,
    fever700,
    fever500,
    warning,
    black,
    white
} from 'Mui/styles/color';

import { componentStyleModes } from 'editor/game_checkIn/components/settingPanel/componentStyleModes';
import {
    redEvelopeBackgroundImg,
    redEvelopeMbBackgroundImg
} from 'components/RedEnvelopeRain/setting';
import { slotsBackgroundImg, slotsMbBackgroundImg } from 'components/Slots/const';
import {
    PICK_THE_PRIZE_BACKGROUND_IMAGE_PC_URL,
    PICK_THE_PRIZE_BACKGROUND_IMAGE_MB_URL
} from 'components/PickThePrize/const';
import { POINTS_REDEEM_BACKGROUND_IMAGE_URL } from 'components/PointsRedeem/const';
import { defaultGameSetting as memoryMatchDefaultGameSetting } from 'components/MemoryMatch/Core/constants/games';
import { defaultStyleSetting as memoryMatchDefaultStyleSetting } from 'components/MemoryMatch/Core/constants/styles';
import { ugcGameSetting } from 'ugc/components/workPage/SettingPreviews/defaultGameSetting';
import { galleryGameSetting } from 'editor/components/Gallery/SettingPreviews/defaultGameSetting';
import { bgTypes } from 'styles/generateBgStyleByType';
import { froalaKeyVisionTypeMapping } from 'components/KeyVision/config';
import { COVER_TABS } from 'editor/components/CoverPage/config';
import { convertRGBtoRGBA } from 'utils/colorConvert';
import { SHARE_CARD_IMAGE_TYPES } from 'editor/game_mgmShare/utils/constants';
import { isCustomResultGames } from 'config/promoGameTypes';

export const getCoverPageContent = title => `
<div>
	<br> 
	<br>
	<h2 class="section-title" style="text-align: center;">
	   <strong>${title || i18nLangOfGame.t('default_val.cover_page_main_title')}</strong>
	</h2>

	<p class="inner" style="text-align: center;">
		${i18next.t('default_val.cover_page_sub_title')}</p>

    <div style="text-align: center;">
            <span style="text-align: center; width: 140px; height: 140px;">
                <img 
                    src="https://assets.fevercdn.com/promotion/img/cover_page_image/uploadImage.png"
                    class="fr-fic fr-dii lazyload"
                    style="width: 140px; height: 140px;"
                />
            </span>
    </div>

	<p style="text-align: center; margin: 24px 0px;">
		<a class="simple-button-plugin" href="#" rel="noopener noreferrer" style="display: inline-block; background-color: #0071FF; border: 2px solid #FFFFFF; padding: 14px 40px; letter-spacing: 1px; border-radius: 100px; font-size: 24px; cursor: pointer; color: rgb(255, 255, 255); font-weight: 500; text-decoration: none !important;">${i18next.t(
            'default_val.cover_page_btn_text'
        )}</a>
	</p>
    <br> 
	<br>
    <br>
</div>
`;

export const getInvoiceTitleTextboxContent = title =>
    `<h2 class="section-title" style="text-align: center;">${title}</h2>`;

export const getDefaultFroalaText = (title, color = '#FFF') =>
    ` <h2 class="section-title" style="text-align: center;">
        <span style="color:${color};">
            <strong class="bold">
                ${title}
            </strong>
        </span>
    </h2>`;

export const getUgcFroalaText = title =>
    ` <h2 class="section-title" style="text-align: center; padding: 24px; width:100%">
        <span style="color: #FFFFFF;">
            <strong class="bold">
                ${title}
            </strong>
        </span>
    </h2>`;

export const getTaskPromoFroalaText = (title, color = black.color) =>
    `<h1 class="cover-title" text-align: center;"><strong class="bold" style="color:${color};">${title}</strong></h1>`;

const votingDefaultSetting = {
    settingPromo: {
        // TODO: 需要請後端增加預設值
        enableReCaptcha: 1
    },
    settingGame: {
        entryVotes: 1
    }
};

export const SHARE_CHANNEL_ORDER = ['LINE', 'FACEBOOK', 'WHATSAPP', 'X', 'COPY', 'OTHER'];

export const defaultReferralShareCard = gameType => {
    const hasCustomResult = Boolean(isCustomResultGames(gameType));
    return {
        referralShareCard: {
            //邀請標題
            invitationTitle: hasCustomResult ? '{{promo:result:title}}' : '',
            //邀請說明
            invitationDesc: `@username ${i18next.t('label.mgm_share.invitation_title')}`,
            // 邀請按鈕文字
            buttonText: i18next.t('default_val.sign_up.referral_code_card.button_text'),
            // 邀請按鈕文字顏色
            buttonTextColor: '#ffffff',
            // 邀請按鈕背景顏色
            buttonBgColor: system900.color,
            // 主題文字顏色
            themeTextColor: system900.color,
            // 主題背景顏色
            themeBgColor: '#ffffff',
            //分享管道設定
            shareChannel: {
                LINE: true,
                FACEBOOK: true,
                WHATSAPP: false,
                X: false,
                COPY: true,
                OTHER: true
            },
            resultImageType: hasCustomResult
                ? SHARE_CARD_IMAGE_TYPES.GAME_RESULT
                : SHARE_CARD_IMAGE_TYPES.CUSTOM
        }
    };
};

export const defaultResultPageSettings = () => ({
    resultPage: {
        winnerButtonText: i18next.t(
            'label.check_in.lottery_task_card.unlocked.participant_prize.luck'
        ),
        rejoinButtonText: i18next.t('btn.join_again'),
        recordButtonText: i18next.t('btn.join_record'),
        sponsorSlotEnabled: false,
        shareSlotEnabled: true,
        sponsorSlotFroalaEditor: `<h4 class="inner-title" style="text-align: center;"><strong class="bold">${i18next.t(
            'label.froala_editor.sponsor_slot'
        )}</strong></h4>`,
        referralShareFroalaEditor: `<p style="text-align: center;"><strong class="bold">${i18next.t(
            'label.froala_editor.referral_share'
        )}</strong></p>`
    }
});

export const defaultReferralButton = (isFallbackVersion = false, isEditor = false) => {
    const t = id => (isEditor ? i18nLangOfGame.t(id) : i18next.t(id));
    return {
        referralButton: {
            buttonText: isFallbackVersion ? '' : t('btn.referral_friend_join'),
            buttonTextColor: '#FFF',
            buttonBgColor: isFallbackVersion ? system900.color : promo500.color,
            isShowButton: true
        }
    };
};

export const getPromoMgmMissionDefaultSettingValue = gameType => {
    const config = {
        [gameTypes.SIGN_UP]: {
            settingMGMReferral: {
                enableReferralCodeRequired: 1,
                referralCodeCard: {
                    buttonText: i18nLangOfGame.t(
                        'default_val.sign_up.referral_code_card.button_text'
                    )
                }
            }
        }
    };

    return (
        config[gameType] || {
            settingMGMReferral: {
                enableReferralCodeRequired: 0,
                referralCodeCard: {
                    isShowImage: true,
                    imageUrl: 'https://assets.fevercdn.com/promotion/img/prize-image.svg',
                    buttonText: i18nLangOfGame.t(
                        'default_val.sign_up.referral_code_card.button_text'
                    ),
                    buttonTextColor: '#fff',
                    buttonBgColor: system900.color,
                    description: i18nLangOfGame.t(
                        'default_val.sign_up.referral_code_card.description'
                    ),
                    themeTextColor: system900.color,
                    themeBgColor: '#FFF'
                }
            }
        }
    );
};

export const defaultPopupColor = {
    popupTextColor: system900.color,
    popupButtonTextColor: white.color,
    popupButtonBgColor: promo500.color,
    popupBgColor: white.color
};

export const getPromoDefaultSettingValue = (gameType, relatedWith) => {
    const config = {
        [gameTypes.PSYCHO_QUIZ]: {
            settingStyle: {
                buttonBgColor: '#0071ff',
                buttonTextColor: '#fff',
                optionBgColor: system200.color,
                optionTextColor: '#333',
                titleColor: '#333',
                descColor: '#333',
                buttonSize: 'sm',
                contentAlign: 'left',
                contentBgColor: convertRGBtoRGBA('#fff', 0.5)
            },
            settingGameStyle: {
                coverSetting: {
                    foregroundTab: bgTypes.FROALA,
                    foregroundDesktopImg: '',
                    foregroundMobileImg: '',
                    backgroundEnabled: false,
                    backgroundTab: COVER_TABS.PRESET,
                    backgroundType: bgTypes.SVG,
                    backgroundDesktopImg: '',
                    backgroundMobileImg: '',
                    backgroundColor: '#FFFFFF'
                }
            }
        },
        [gameTypes.SIGN_FORM]: {
            settingGame: {
                contentBgColor: convertRGBtoRGBA('#fff', 0.5)
            },
            settingGameStyle: {
                coverSetting: {
                    foregroundTab: bgTypes.FROALA,
                    foregroundDesktopImg: '',
                    foregroundMobileImg: '',
                    backgroundEnabled: false,
                    backgroundTab: COVER_TABS.PRESET,
                    backgroundType: bgTypes.SVG,
                    backgroundDesktopImg: '',
                    backgroundMobileImg: '',
                    backgroundColor: '#FFFFFF'
                }
            }
        },
        [gameTypes.QUIZ]: {
            settingStyle: {
                buttonBgColor: '#0071ff',
                buttonTextColor: '#fff',
                optionBgColor: system200.color,
                optionTextColor: '#333',
                titleColor: '#333',
                descColor: '#333',
                buttonSize: 'sm',
                contentAlign: 'left',
                contentBgColor: convertRGBtoRGBA('#fff', 0.5)
            },
            settingGame: {
                changeQuestionOn: 2,
                playOnce: 0,
                maxFailure: 0,
                timeLimit: 0
            },
            settingGameStyle: {
                coverSetting: {
                    foregroundTab: bgTypes.FROALA,
                    foregroundDesktopImg: '',
                    foregroundMobileImg: '',
                    backgroundEnabled: false,
                    backgroundTab: COVER_TABS.PRESET,
                    backgroundType: bgTypes.SVG,
                    backgroundDesktopImg: '',
                    backgroundMobileImg: '',
                    backgroundColor: '#FFFFFF'
                }
            }
        },
        [gameTypes.VOTE]: {
            settingStyle: {
                buttonBgColor: '#0071ff',
                buttonTextColor: '#fff',
                optionBgColor: system200.color,
                optionTextColor: '#333',
                titleColor: '#333',
                descColor: '#333',
                buttonSize: 'sm',
                contentAlign: 'left',
                contentBgColor: convertRGBtoRGBA('#fff', 0.5)
            },
            settingGame: {
                voteRateDisplayMethod: 2,
                resultOptionSortMethod: 1
            },
            settingGameStyle: {
                coverSetting: {
                    foregroundTab: bgTypes.FROALA,
                    foregroundDesktopImg: '',
                    foregroundMobileImg: '',
                    backgroundEnabled: false,
                    backgroundTab: COVER_TABS.PRESET,
                    backgroundType: bgTypes.SVG,
                    backgroundDesktopImg: '',
                    backgroundMobileImg: '',
                    backgroundColor: '#FFFFFF'
                }
            }
        },
        [gameTypes.SURVEY]: {
            settingGameStyle: {
                coverSetting: {
                    foregroundTab: bgTypes.FROALA,
                    foregroundDesktopImg: '',
                    foregroundMobileImg: '',
                    backgroundEnabled: false,
                    backgroundTab: COVER_TABS.PRESET,
                    backgroundType: bgTypes.SVG,
                    backgroundDesktopImg: '',
                    backgroundMobileImg: '',
                    backgroundColor: '#FFFFFF'
                }
            }
        },
        [gameTypes.RED_ENVELOPE_RAIN]: {
            settingStyle: {
                bgType: bgTypes.IMG,
                bgImgUrl: redEvelopeBackgroundImg,
                bgMobileImgUrl: redEvelopeMbBackgroundImg,
                bgColor: system050.color,
                contentBgColor: 'transparent'
            }
        },
        [gameTypes.INVOICE]: {
            settingStyle: {
                contentBgColor: convertRGBtoRGBA('#fff', 0.5),
                buttonBgColor: '#0071ff',
                buttonTextColor: '#fff',
                optionBgColor: system200.color,
                optionTextColor: '#333',
                titleColor: '#333',
                descColor: '#333',
                buttonSize: 'sm',
                contentAlign: 'left'
            },
            settingGame: {
                enableInvoiceDetailRead: 1,
                enableInvoiceRealtimeValidation: 1,
                enableInvoiceImgUpload: 1,
                validation: {
                    keywords: {
                        combinations: [
                            {
                                items: [[[]]],
                                logicOperators: [],
                                totalCountLimit: 1,
                                totalAmountLimit: 0
                            }
                        ],
                        logicOperators: []
                    },
                    sellers: { type: 0 },
                    totalCountLimit: 1,
                    totalCountLimitType: 1,
                    totalAmountLimit: 0,
                    totalAmountLimitType: 0
                }
            }
        },
        [gameTypes.PHOTO_UPLOAD]: {
            settingStyle: {
                titleColor: 'rgba(0, 0, 0, 1)',
                descColor: 'rgba(0, 0, 0, 1)',
                buttonTextColor: 'rgba(255, 255, 255, 1)',
                buttonBgColor: '#000000',
                contentBgColor: convertRGBtoRGBA('#f8f8f8', 0.5),
                bgColor: 'rgb(236, 236, 236)'
            },
            settingGame: {
                ...(relatedWith.gameType === gameTypes.CONTEST_ADMIN_UPLOAD
                    ? {
                          btnText: i18nLangOfGame.t('btn.voting_contest.redirct.voting_page'),
                          guidance: i18nLangOfGame.t('placeholder.voting_contest.voting_title'),
                          guidanceNote: i18nLangOfGame.t('placeholder.voting_contest.voting_desc')
                      }
                    : {
                          guidance: i18nLangOfGame.t('label.photo_upload.guidance_default_value'),
                          guidanceNote: i18nLangOfGame.t(
                              'label.photo_upload.guidance_note_default_value'
                          )
                      }),
                copyrightClause: i18nLangOfGame.t(
                    'desc.photo_upload.copyright_clause_default_value'
                ),
                enableImageTitleInput: 1,
                enableImageDescriptionInput: 0,
                enableUgcAuthorNameInput: 0,
                mediaLibrariesSort: 2,
                // galleryTemplateType: ugcGalleryTypes.COLUMN_WATERFALL,
                ugcGameSetting: ugcGameSetting,
                galleryGameSetting: galleryGameSetting
            }
        },
        [gameTypes.CHECK_IN]: {
            settingStyle: {
                titleColor: '#000',
                descColor: '#000',
                contentBorderRadius: 35,
                contentBgColor: convertRGBtoRGBA('#f8f8f8', 0.5),
                lotteryTaskTextColor: '#000',
                lotteryTaskBgColor: '#FFB200'
            },
            settingGame: {
                title: {
                    value: i18nLangOfGame.t('default_val.check_in.title'),
                    enable: 1
                },
                description: {
                    value: i18nLangOfGame.t('default_val.check_in.desc'),
                    enable: 1
                },
                mainViewImg: {
                    value:
                        'https://assets.fevercdn.com/promotion/img/check_in/check_in_main_img.png',
                    enable: 1
                },
                signInBtn: {
                    type: componentStyleModes.SYSTEM,
                    color: '#fff',
                    backgroundColor: '#02A0FC'
                },
                signInSlot: {
                    type: componentStyleModes.SYSTEM,
                    textColor: '#000',
                    colorSigned: '#FFB200',
                    colorUnSigned: '#FFF0B4',
                    quantityPerRow: 4,
                    dayCount: 7
                }
            }
        },
        [gameTypes.CONTEST_PHOTO_UPLOAD]: {
            ...votingDefaultSetting
        },
        [gameTypes.PHOTO_FRAME_COMPOSITE]: {
            settingStyle: {
                titleColor: 'rgba(0, 0, 0, 1)',
                descColor: 'rgba(0, 0, 0, 1)',
                buttonTextColor: 'rgba(255, 255, 255, 1)',
                buttonBgColor: '#000000',
                bgColor: '#EEEEEE',
                contentBgColor: convertRGBtoRGBA('#F5F5F5', 0.5)
            },
            settingGame: {
                guidance: i18nLangOfGame.t('label.photo_upload.guidance_default_value'),
                guidanceNote: i18nLangOfGame.t('label.photo_upload.guidance_note_default_value'),
                copyrightClause: i18nLangOfGame.t(
                    'desc.photo_upload.copyright_clause_default_value'
                ),
                enableImageTitleInput: 1,
                enableImageDescriptionInput: 0,
                enableUgcAuthorNameInput: 0,
                mediaLibrariesSort: 2,
                // galleryTemplateType: ugcGalleryTypes.COLUMN_WATERFALL,
                enableFixedFrameHeight: 0,
                ugcGameSetting: ugcGameSetting,
                galleryGameSetting: galleryGameSetting
            }
        },
        [gameTypes.SLOTS]: {
            settingStyle: {
                bgType: bgTypes.IMG,
                bgImgUrl: slotsBackgroundImg,
                bgMobileImgUrl: slotsMbBackgroundImg,
                bgColor: system050.color,
                contentBgColor: 'transparent',
                titleColor: '#fff'
            }
        },
        [gameTypes.MEMORY_MATCH]: {
            settingStyle: {
                ...memoryMatchDefaultStyleSetting
            },
            settingGame: {
                ...memoryMatchDefaultGameSetting
            }
        },
        [gameTypes.PICK_THE_PRIZE]: {
            settingStyle: {
                bgType: bgTypes.IMG,
                bgImgUrl: PICK_THE_PRIZE_BACKGROUND_IMAGE_PC_URL,
                bgMobileImgUrl: PICK_THE_PRIZE_BACKGROUND_IMAGE_MB_URL,
                bgColor: system050.color,
                contentBgColor: 'transparent'
            }
        },
        [gameTypes.COMMENT]: {
            settingStyle: {
                titleColor: 'rgba(0, 0, 0, 1)',
                descColor: 'rgba(0, 0, 0, 1)',
                buttonTextColor: 'rgba(255, 255, 255, 1)',
                buttonBgColor: '#000000',
                contentBgColor: convertRGBtoRGBA('#F5F5F5', 0.5),
                bgColor: '#EEEEEE'
            },
            settingGame: {
                guidance: i18nLangOfGame.t('placeholder.comment.guidance'),
                guidanceNote: i18nLangOfGame.t('label.photo_upload.guidance_note_default_value'),
                enableFixedAspectRatio: 1,
                enableParticipantName: 1
            }
        },
        [gameTypes.CONTEST_ADMIN_UPLOAD]: {
            ...votingDefaultSetting
        },
        [gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE]: {
            settingStyle: {
                titleColor: '#000',
                descColor: '#000',
                optionTextColor: '#000',
                optionBgColor: '#fff',
                lotteryTaskTextColor: '#000',
                lotteryTaskBgColor: '#fff',
                contentBorderRadius: 35,
                contentBgColor: convertRGBtoRGBA(promo100.color, 0.5)
            },
            settingGame: {
                title: {
                    value: i18nLangOfGame.t('default_val.challenge_photo_frame.title'),
                    enable: 1
                },
                description: {
                    value: i18nLangOfGame.t('default_val.challenge_photo_frame.desc'),
                    enable: 1
                },
                mainViewImg: {
                    value: 'https://assets.fevercdn.com/promotion/img/challenge/main_img.svg',
                    enable: 1
                },
                enableTaskCardTitle: 1,
                enableTaskCardButton: 1,
                // 闖關限制 - 此設定可以限制參加者的闖關順序
                enableTaskJoinBySeq: 1,
                taskCardPerRow: {
                    desktop: 3,
                    mobile: 2
                },
                // 以下和其他 ugc 相框 相同
                enableImageTitleInput: 1,
                enableImageDescriptionInput: 0,
                enableUgcAuthorNameInput: 0,
                copyrightClause: i18nLangOfGame.t(
                    'desc.photo_upload.copyright_clause_default_value'
                ),
                mediaLibrariesSort: 2,
                // galleryTemplateType: ugcGalleryTypes.COLUMN_WATERFALL,
                ugcGameSetting: ugcGameSetting,
                galleryGameSetting: galleryGameSetting
            }
        },
        [gameTypes.CONTEST_PHOTO_FRAME_COMPOSITE]: {
            ...votingDefaultSetting
        },
        [gameTypes.VIDEO_UPLOAD]: {
            settingStyle: {
                titleColor: 'rgba(0, 0, 0, 1)',
                descColor: 'rgba(0, 0, 0, 1)',
                buttonTextColor: 'rgba(255, 255, 255, 1)',
                buttonBgColor: '#000000',
                contentBgColor: convertRGBtoRGBA('#f8f8f8', 0.5),
                bgColor: 'rgb(236, 236, 236)'
            },
            settingGame: {
                ...(relatedWith.gameType === gameTypes.CONTEST_ADMIN_UPLOAD
                    ? {
                          btnText: i18nLangOfGame.t('btn.voting_contest.redirct.voting_page'),
                          guidance: i18nLangOfGame.t('placeholder.voting_contest.voting_title'),
                          guidanceNote: i18nLangOfGame.t('placeholder.voting_contest.voting_desc')
                      }
                    : {
                          guidance: i18nLangOfGame.t('desc.video_upload.guidance'),
                          guidanceNote: i18nLangOfGame.t('desc.ugc.guidance_note')
                      }),
                copyrightClause: i18nLangOfGame.t(
                    'desc.photo_upload.copyright_clause_default_value'
                ),
                enableUgcTitleInput: 1,
                enableUgcDescriptionInput: 0,
                enableUgcAuthorNameInput: 0,
                mediaLibrariesSort: 2,
                // galleryTemplateType: ugcGalleryTypes.COLUMN_WATERFALL,
                ugcGameSetting: ugcGameSetting,
                galleryGameSetting: galleryGameSetting
            }
        },
        [gameTypes.CONTEST_VIDEO_UPLOAD]: {
            ...votingDefaultSetting
        },
        [gameTypes.INSTAGRAM]: {
            settingStyle: {
                contentBgColor: convertRGBtoRGBA('#fff', 0.5),
                buttonBgColor: '#6F3FC8',
                buttonTextColor: '#FFFFFF',
                buttonBorderColor: '#5B31A9',
                titleBgColor: '#341C61',
                titleColor: '#FFFFFF',
                optionTextColor: '#341C61',
                optionBgColor: '#E9E2F7'
            },
            settingGame: {
                html: `
                    <h2><strong>${i18nLangOfGame.t(
                        'label.game_instagram.editor.title'
                    )}</strong></h2>
                    <h4><strong>${i18nLangOfGame.t(
                        'label.game_instagram.editor.desc'
                    )}</strong></h4>
                `,
                enablePrivateReply: 1,
                privateReplyTitle: i18nLangOfGame.t('label.game_instagram.private_reply_title'),
                headerText: i18nLangOfGame.t('label.game_instagram.header_text'),
                instruction: i18nLangOfGame.t('label.game_instagram.instruction'),
                btnText: i18nLangOfGame.t('label.game_instagram.btn_text'),
                instagramPostReply: i18nLangOfGame.t('label.game_instagram.post_reply'),
                ugcGameSetting: ugcGameSetting,
                galleryGameSetting: galleryGameSetting,
                instagramPrivateReplyMessage: {
                    entryExistIntroMsg: i18nLangOfGame.t(
                        'label.game_instagram.entry_exist_intro_msg'
                    ),
                    entryExistTemplateCardMsg: {
                        template_type: 'generic',
                        elements: [
                            {
                                title: i18nLangOfGame.t(
                                    'label.game_instagram.generic_template.title'
                                ),
                                image_url:
                                    'https://assets.fevercdn.com/promotion/img/memoryMatch_cardBack.jpg',
                                subtitle: i18nLangOfGame.t(
                                    'desc.game_instagram.generic_template.subtitle'
                                ),
                                default_action: {
                                    type: 'web_url',
                                    url: '',
                                    webview_height_ratio: 'tall'
                                },
                                buttons: [
                                    {
                                        type: 'web_url',
                                        url: '',
                                        title: i18nLangOfGame.t('btn.get_winner')
                                    }
                                ]
                            }
                        ]
                    },
                    entryNotExistIntroMsg: i18nLangOfGame.t(
                        'label.game_instagram.entry_not_exist_intro_msg'
                    ),
                    entryNotExistTemplateCardMsg: {
                        template_type: 'generic',
                        elements: [
                            {
                                title: i18nLangOfGame.t(
                                    'label.game_instagram.generic_template.title'
                                ),
                                image_url:
                                    'https://assets.fevercdn.com/promotion/img/memoryMatch_cardBack.jpg',
                                subtitle: i18nLangOfGame.t(
                                    'desc.game_instagram.generic_template.subtitle'
                                ),
                                default_action: {
                                    type: 'web_url',
                                    url: '',
                                    webview_height_ratio: 'tall'
                                },
                                buttons: [
                                    {
                                        type: 'web_url',
                                        url: '',
                                        title: i18nLangOfGame.t('btn.get_winner')
                                    }
                                ]
                            }
                        ]
                    },
                    quickReplyMsg: i18nLangOfGame.t('label.game_instagram.quickly_replay_msg'),
                    quickReplyOption: i18nLangOfGame.t('label.game_instagram.quickly_replay_opt')
                }
            }
        },
        [gameTypes.PURCHASE_REWARD]: {
            settingStyle: {
                buttonBgColor: zines500.color,
                buttonTextColor: '#fff',
                actionButtonText: i18nLangOfGame.t('default_val.purchase_reward.title_text'),
                optionBgColor: system200.color,
                optionTextColor: '#333',
                titleColor: '#333',
                descColor: '#333',
                contentAlign: 'left',
                contentBgColor: convertRGBtoRGBA('#fff', 0.5)
            },
            settingGame: {
                // 品項關係
                itemValidationLogicOperators: 'OR',
                // 買方限制
                buyers: {
                    type: 0 // 0：無限制 , 1：過濾買方統編
                },
                // 通路限制
                sellers: {
                    type: 0, // 0：無限制 , 1：賣方統編 , 2：賣方名稱 , 3：賣方地址
                    addresses: [], // 限制賣方地址
                    names: [], // 限制賣方名稱
                    taxIdNumbers: [] // 限制賣方統編
                },
                // 金額門檻
                amount: {
                    totalAmountLimit: 0, // 金額門檻總金額
                    type: 0 // 金額門檻Type  - 0 : 無限制 / 1 : 發票總金額 / 2 : 品項總金額
                },
                // 日期限制
                dateRange: {
                    type: 0, // 0 : 無限制 / 1 : 指定時間區段
                    startDate: '', // 起始日期
                    endDate: '' // 結束日期
                }
            },
            settingGameStyle: {
                consumptionDateDescription: i18nLangOfGame.t(
                    'default_val.purchase_reward.purchase_date_description_text'
                ),
                consumptionDateTitle: i18nLangOfGame.t(
                    'default_val.purchase_reward.purchase_date_text'
                ),
                invoiceNumberDescription: i18nLangOfGame.t(
                    'default_val.purchase_reward.invoice_number_description_text'
                ),
                invoiceNumberTitle: i18nLangOfGame.t(
                    'default_val.purchase_reward.invoice_number_text'
                ),
                randomNumberDescription: i18nLangOfGame.t(
                    'default_val.purchase_reward.random_number_description_text'
                ),
                randomNumberTitle: i18nLangOfGame.t(
                    'default_val.purchase_reward.random_number_text'
                ),
                receiptDescription: i18nLangOfGame.t(
                    'default_val.purchase_reward.receipt_number_description_text'
                ),
                receiptTitle: i18nLangOfGame.t('default_val.purchase_reward.receipt_number_text'),
                carrierNumberTitle: i18nLangOfGame.t(
                    'default_val.purchase_reward.carrier_number_text'
                ),
                carrierNumberDescription: i18nLangOfGame.t(
                    'default_val.purchase_reward.carrier_number_description_text'
                ),
                carrierCodeTitle: i18nLangOfGame.t('default_val.purchase_reward.carrier_code_text'),
                carrierCodeDescription: i18nLangOfGame.t(
                    'default_val.purchase_reward.carrier_code_description_text'
                ),
                uploadImageDescription: i18nLangOfGame.t(
                    'default_val.purchase_reward.upload_img_description_text'
                ),
                uploadImageTitle: i18nLangOfGame.t('default_val.purchase_reward.upload_img_text'),
                keyVisionSettings: {
                    bgType: bgTypes.FROALA,
                    bgColor: 'rgba(0,67,216,1)',
                    customImgUrl: '',
                    customMobileImgUrl: '',
                    defaultMainVisionType: froalaKeyVisionTypeMapping.COLOR,
                    froalaEditor: '',
                    isShowKeyVision: true
                }
            }
        },
        [gameTypes.POINTS_REDEEM]: {
            settingStyle: {
                bgType: bgTypes.IMG,
                bgImgUrl: POINTS_REDEEM_BACKGROUND_IMAGE_URL,
                bgMobileImgUrl: POINTS_REDEEM_BACKGROUND_IMAGE_URL,
                bgColor: '#FFF5CD',
                titleColor: black.color,
                descColor: black.color,
                buttonBgColor: fever500.color,
                buttonTextColor: white.color,
                contentBgColor: convertRGBtoRGBA(warning.color, 0.5)
            }
        },
        [gameTypes.MGM_SHARE]: {
            settingStyle: {
                titleColor: '#000',
                contentBorderRadius: 35,
                contentBgColor: convertRGBtoRGBA('#f8f8f8', 0.5),
                lotteryTaskTextColor: '#000',
                lotteryTaskBgColor: '#FFB200'
            },
            settingGameStyle: {
                // 主視覺設定
                keyVisionSettings: {
                    bgType: bgTypes.FROALA,
                    bgColor: '#FFB54A',
                    customImgUrl: '',
                    customMobileImgUrl: '',
                    defaultMainVisionType: froalaKeyVisionTypeMapping.COLOR,
                    froalaEditor: `<p><br></p>
                    <p><br></p>
                    <h1 class="cover-title" style="color: rgb(0, 0, 0); text-align: center;"><strong class="bold">${i18nLangOfGame.t(
                        'label.mgm_share.froala.title'
                    )}</strong></h1>
                    <div><img src="https://assets.fevercdn.com/picture-origin/production/feversocial/promotions/12892/20230814101844_64d9ff843cae3.png" class="lazyload" data-width="749" data-ratio="0.231" style="width: 720px;"></div>`,
                    isShowKeyVision: true
                },
                // 按鈕設定
                actionButtonSettings: {
                    // 設定方式 ( 1 : 預設樣式 / 2 : 自訂樣式 )
                    type: 1,
                    // 按鈕文案
                    text: i18nLangOfGame.t('lable.mgm_share.action_button_text'),
                    // 文字顏色
                    textColor: '#ffffff',
                    // 背景顏色
                    bgColor: fever700.color,
                    // 按鈕連結 ( 下載 App 註冊才會提供編輯，官網註冊直接導轉至設定的 link )
                    link: '',
                    // 自訂樣式圖片 Url
                    customImgUrl: ''
                },
                // Froala
                froalaEditor: `<h3 class="section-subtitle" style="height: 48px; text-align: center; width: 100%;">
                <strong class="bold">${i18nLangOfGame.t(
                    'label.sign_up.unregistaer_froala.title'
                )}</strong></h3>
            
            <ol style="text-align: left;">
                <li><strong class="bold">${i18nLangOfGame.t(
                    'label.mgm_share.froala.old_member_join'
                )}</strong></li>
                <li><strong class="bold">${i18nLangOfGame.t(
                    'label.mgm_share.froala.one_account_get_one_prize'
                )}</strong></li>
                <li><strong class="bold">${i18nLangOfGame.t(
                    'label.sign_up.unregistaer_froala.prize_term'
                )}</strong></li>
                <li><strong class="bold">${i18nLangOfGame.t(
                    'label.sign_up.unregistaer_froala.join_term'
                )}</strong></li>
            </ol>`
            }
        },
        [gameTypes.SIGN_UP]: {
            settingStyle: {
                optionBgColor: '#1B7368',
                optionTextColor: '#FFFFFF',
                titleColor: '#333',
                contentBgColor: convertRGBtoRGBA('#FFF7EE', 0.5)
            },
            settingGameStyle: {
                // 未註冊頁面 - 主視覺設定
                unregisterKeyVisionSettings: {
                    bgType: bgTypes.FROALA,
                    bgColor: 'rgba(228,134,38,1)',
                    customImgUrl: '',
                    customMobileImgUrl: '',
                    defaultMainVisionType: froalaKeyVisionTypeMapping.COLOR,
                    froalaEditor: `<p><br></p>
                    <p><br></p>
                    <h1 class="cover-title" style="color: rgb(0, 0, 0); text-align: center;"><strong class="bold">${i18nLangOfGame.t(
                        'label.game_type.sign_up.key_vision_title'
                    )}</strong></h1>
                    <div><img src="https://assets.fevercdn.com/picture-origin/production/feversocial/promotions/12907/20230825105545_64e888b127c57.png" class="lazyload" data-width="176" data-ratio="0.688" style="width: 240px;"></div>`,
                    isShowKeyVision: true
                },
                // 未註冊頁面 - 按鈕設定
                actionButtonSettings: {
                    // 設定方式 ( 1 : 預設樣式 / 2 : 自訂樣式 )
                    type: 1,
                    // 按鈕文案
                    text: '',
                    // 文字顏色
                    textColor: '#FFF',
                    // 背景顏色
                    bgColor: '#1B7368',
                    // ios 按鈕連結 ( 下載 App 註冊才會提供編輯)
                    iosLink: '',
                    // android 按鈕連結 ( 下載 App 註冊才會提供編輯 )
                    androidLink: '',
                    // 其他裝置按鈕連結 ( 下載 App 註冊才會提供編輯 )
                    otherLink: '',
                    // 自訂樣式圖片 Url
                    customImgUrl: ''
                },
                // 未註冊頁面 - Froala
                unregisterFroalaEditor: `<h3 class="section-subtitle" style="height: 48px; text-align: center; width: 100%;">
	<strong class="bold">${i18nLangOfGame.t('label.sign_up.unregistaer_froala.title')}</strong></h3>

<ol>
	<li><strong class="bold">${i18nLangOfGame.t(
        'label.sign_up.unregistaer_froala.new_register_join'
    )}</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t(
        'label.sign_up.unregistaer_froala.one_account_get_one_prize'
    )}
</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t('label.sign_up.unregistaer_froala.prize_term')}
</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t(
        'label.sign_up.unregistaer_froala.join_term'
    )}</strong></li>
</ol>`,
                // 已註冊頁面 - 主視覺
                registeredKeyVisionSettings: {
                    bgType: bgTypes.FROALA,
                    bgColor: 'rgba(228,134,38,1)',
                    customImgUrl: '',
                    customMobileImgUrl: '',
                    defaultMainVisionType: froalaKeyVisionTypeMapping.COLOR,
                    froalaEditor: `<p><br></p>
                    <p><br></p>
                    <h1 class="cover-title" style="color: rgb(0, 0, 0);text-align: center;"><strong class="bold">${i18nLangOfGame.t(
                        'label.game_type.sign_up.key_vision_title'
                    )}</strong></h1>
                    <div><img src="https://assets.fevercdn.com/picture-origin/production/feversocial/promotions/12907/20230825105545_64e888b127c57.png" class="lazyload" data-width="176" data-ratio="0.688" style="width: 240px;"></div>`,
                    isShowKeyVision: true
                },
                // 已註冊頁面 - Froala
                registeredFroalaEditor: `<p style="text-align: center;"><strong class="bold">${i18nLangOfGame.t(
                    'label.sign_up.registaered_froala.welcome_join'
                )}<br>${i18nLangOfGame.t(
                    'label.sign_up.registaered_froala.welcome_text'
                )}</strong><strong class="bold">
                </strong></p>
                
                <p style="text-align: center;"><a class="simple-button-plugin" href="#" rel="noopener noreferrer" style="display: inline-block; background-color: rgb(0, 0, 0); margin: 8px; border: 1px solid transparent; padding: 10px 20px; letter-spacing: 1px; border-radius: 40px; font-size: 20px; cursor: pointer; color: rgb(255, 255, 255); text-decoration: none !important;"><strong class="bold">${i18nLangOfGame.t(
                    'label.sign_up.registaered_froala.go_to_new_member_shop'
                )}</strong></a></p>`
            }
        },
        [gameTypes.MULTI_CHALLENGE]: {
            settingStyle: {
                // 關卡獎說明文字顏色
                descColor: '#000',
                // 關卡選項的文字顏色
                optionTextColor: '#000',
                // 關卡選項的背景顏色
                optionBgColor: '#fff',
                // 關卡獎卡牌文字顏色
                lotteryTaskTextColor: '#000',
                // 關卡獎卡牌背景顏色
                lotteryTaskBgColor: '#fff',
                // 不清楚
                contentBorderRadius: 35,
                // 題組背景顏色
                contentBgColor: convertRGBtoRGBA('#FFEBBC', 0.5)
            },
            settingGameStyle: {
                // 主視覺設定
                keyVisionSettings: {
                    bgType: bgTypes.FROALA,
                    bgColor: zines500.color,
                    customImgUrl: '',
                    customMobileImgUrl: '',
                    defaultMainVisionType: froalaKeyVisionTypeMapping.COLOR,
                    froalaEditor: getTaskPromoFroalaText(
                        i18nLangOfGame.t('default_val.multi_challenge.title')
                    ),
                    isShowKeyVision: true
                },
                // 按鈕設定
                actionButtonSettings: {
                    // 設定方式 ( 1 : 預設樣式 / 2 : 自訂樣式 )
                    type: 1,
                    // 按鈕文案
                    text: i18nLangOfGame.t('label.multi_challenge.action_button_text'),
                    // 文字顏色
                    textColor: white.color,
                    // 背景顏色
                    bgColor: zines500.color,
                    // 自訂樣式圖片 Url
                    customImgUrl: ''
                },
                // (顯示/隱藏) 闖關卡牌按鈕
                enableTaskCardButton: 1,
                // (顯示/隱藏) 闖關活動說明
                enableTaskFroalaEditor: 1,
                // (顯示/隱藏) 闖關卡牌標題
                enableTaskCardTitle: 1,
                // 闖關說明
                froalaEditor: `<h3 class="section-subtitle" style="text-align: center; width: 100%">
                    <strong class="bold">${i18nLangOfGame.t(
                        'default_val.multi_challenge.desc'
                    )}</strong>
                </h3>`
            },
            settingGame: {
                // 闖關限制 - 此設定可以限制參加者的闖關順序 (0: 不限制, 1: 依順序闖關)
                enableTaskJoinBySeq: 0,
                // 關卡排列方式
                taskCardPerRow: {
                    desktop: 3,
                    mobile: 2
                }
                // 關順順序 (PromoTask 控制)
            }
        },
        [gameTypes.ORDER_REWARD]: {
            settingStyle: {
                // 主題樣式
                descColor: '#333', // 文字 -> 說明顏色
                // contentBgColor: '#FFF7EE', // 題組 -> 背景顏色
                contentBgColor: convertRGBtoRGBA('#FFF7EE', 0.5)
            },
            settingGame: {
                // 品項關係
                itemValidationLogicOperators: 'OR',
                // 金額門檻
                amount: {
                    totalAmountLimit: 0, // 金額門檻總金額
                    type: 0 //金額門檻Type - 0 : 無限制/ 1 : 購買總金額(發票總金額)/ 2 : 品項總金額
                },
                // 日期限制
                dateRange: {
                    type: 0, // 0 : 關閉限制購買日期 / 1 : 啟用限制購買日期
                    startDate: '', // 起始日期
                    endDate: '', // 結束日期
                    purchaseWithinDays: 30, // 限制購買後指定天數內登錄
                    enablePurchaseWithinDays: false // 是否啟用限制購買後指定天數內登錄
                }
            },
            settingGameStyle: {
                keyVisionSettings: {
                    bgType: bgTypes.FROALA,
                    bgColor: 'rgba(228,134,38,1)',
                    customImgUrl: '',
                    customMobileImgUrl: '',
                    defaultMainVisionType: froalaKeyVisionTypeMapping.COLOR,
                    froalaEditor: `<p><br></p>
                    <p><br></p>
                    <h1 class="cover-title" style="color: rgb(0, 0, 0);text-align: center;"><strong class="bold">${i18nLangOfGame.t(
                        'label.game_type.order_reward.key_vision_title'
                    )}</strong></h1>
                    <div><img src="https://assets.fevercdn.com/picture-origin/production/feversocial/promotions/12907/20230825105545_64e888b127c57.png" class="lazyload" data-width="176" data-ratio="0.688" style="width: 240px;"></div>`,
                    isShowKeyVision: true
                },
                froalaEditor: `<h3 class="section-subtitle" style="height: 48px; text-align: center;">
	<strong class="bold">${i18nLangOfGame.t('label.froala.promo_rule')}</strong></h3>

<ol>
	<li><strong class="bold">${i18nLangOfGame.t(
        'label.froala_editor.promo_rule.join_term'
    )}</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t('label.froala_editor.promo_rule.sponsor_term')}
</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t('label.froala_editor.promo_rule.prize_term')}
</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t(
        'label.froala_editor.promo_rule.disclaimer'
    )}</strong></li>
</ol>`,
                actionButtonSettings: {
                    // 設定方式 ( 1 : 預設樣式 / 2 : 自訂樣式 )
                    type: 1,
                    // 按鈕文案
                    text: i18nLangOfGame.t('btn.order_reward.action_button'),
                    // 文字顏色
                    textColor: '#FFF',
                    // 背景顏色
                    bgColor: '#D52222',
                    // 自訂樣式圖片 Url
                    customImgUrl: ''
                },
                actionHintText: i18nLangOfGame.t('label.order_reward.hint')
            }
        },
        [gameTypes.CART_REWARD]: {
            settingStyle: {
                // 主題樣式
                // contentBgColor: '#FFF7EE' // 題組 -> 背景顏色
                contentBgColor: convertRGBtoRGBA('#FFF7EE', 0.5)
            },
            settingGame: {
                // 品項關係
                itemValidationLogicOperators: 'OR',
                // 金額門檻
                amount: {
                    totalAmountLimit: 0, // 金額門檻總金額
                    type: 0 //金額門檻Type - 0 : 無限制/ 1 : 購買總金額(發票總金額)/ 2 : 品項總金額
                }
            },
            settingGameStyle: {
                keyVisionSettings: {
                    bgType: bgTypes.FROALA,
                    bgColor: 'rgba(228,134,38,1)',
                    customImgUrl: '',
                    customMobileImgUrl: '',
                    defaultMainVisionType: froalaKeyVisionTypeMapping.COLOR,
                    froalaEditor: `<p><br></p>
                    <p><br></p>
                    <h1 class="cover-title" style="color: rgb(0, 0, 0);text-align: center;"><strong class="bold">${i18nLangOfGame.t(
                        'label.game_type.cart_reward.key_vision_title'
                    )}</strong></h1>
                    <div><img src="https://assets.fevercdn.com/picture-origin/production/feversocial/promotions/12907/20230825105545_64e888b127c57.png" class="lazyload" data-width="176" data-ratio="0.688" style="width: 240px;"></div>`,
                    isShowKeyVision: true
                },
                froalaEditor: `<h3 class="section-subtitle" style="height: 48px; text-align: center;">
	<strong class="bold">${i18nLangOfGame.t('label.froala.promo_rule')}</strong></h3>

<ol>
	<li><strong class="bold">${i18nLangOfGame.t(
        'label.froala_editor.promo_rule.join_term'
    )}</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t('label.froala_editor.promo_rule.sponsor_term')}
</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t('label.froala_editor.promo_rule.prize_term')}
</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t(
        'label.froala_editor.promo_rule.disclaimer'
    )}</strong></li>
</ol>`,
                actionButtonSettings: {
                    // 設定方式 ( 1 : 預設樣式 / 2 : 自訂樣式 )
                    type: 1,
                    // 按鈕文案
                    text: i18nLangOfGame.t('btn.cart_reward.action_button'),
                    // 文字顏色
                    textColor: '#FFF',
                    // 背景顏色
                    bgColor: '#D52222',
                    // 自訂樣式圖片 Url
                    customImgUrl: ''
                }
            }
        },
        [gameTypes.MISSION_REWARD_BY_STAFF]: {
            settingStyle: {
                titleColor: '#000',
                contentBorderRadius: 35,
                contentBgColor: '#f8f8f8',
                optionTextColor: '#000',
                optionBgColor: '#FFB200'
            },
            settingGame: {
                // 品項關係
                itemValidationLogicOperators: 'OR'
            },
            settingGameStyle: {
                keyVisionSettings: {
                    bgType: bgTypes.FROALA,
                    bgColor: 'rgba(228,134,38,1)',
                    customImgUrl: '',
                    customMobileImgUrl: '',
                    defaultMainVisionType: froalaKeyVisionTypeMapping.COLOR,
                    froalaEditor: `<p><br></p>
                    <p><br></p>
                    <h1 class="cover-title" style="color: rgb(0, 0, 0);text-align: center;"><strong class="bold">${i18nLangOfGame.t(
                        'label.game_type_mission_reward_by_staff'
                    )}</strong></h1>
                    <div><img src="https://assets.fevercdn.com/picture-origin/production/feversocial/promotions/12907/20230825105545_64e888b127c57.png" class="lazyload" data-width="176" data-ratio="0.688" style="width: 240px;"></div>`,
                    isShowKeyVision: true
                },
                froalaEditor: `<h3 class="section-subtitle" style="height: 48px; text-align: center;">
	<strong class="bold">${i18nLangOfGame.t('label.froala.promo_rule')}</strong></h3>

<ol>
	<li><strong class="bold">${i18nLangOfGame.t(
        'label.froala_editor.promo_rule.join_term'
    )}</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t('label.froala_editor.promo_rule.sponsor_term')}
</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t('label.froala_editor.promo_rule.prize_term')}
</strong></li>
	<li><strong class="bold">${i18nLangOfGame.t(
        'label.froala_editor.promo_rule.disclaimer'
    )}</strong></li>
</ol>`,
                actionButtonSettings: {
                    // 設定方式 ( 1 : 預設樣式 / 2 : 自訂樣式 )
                    type: 1,
                    // 按鈕文案
                    text: i18nLangOfGame.t('label.entry_qr_code.entry_qr_code_hint'),
                    // 文字顏色
                    textColor: '#000',
                    // 背景顏色
                    bgColor: '#FFCB00',
                    // 自訂樣式圖片 Url
                    customImgUrl: ''
                }
            }
        },
        [gameTypes.WIN_WHEEL]: {
            contentBgColor: 'transparent'
        },
        [gameTypes.POKE_GAME]: {
            contentBgColor: 'transparent'
        },
        [gameTypes.SCRATCH_CARD]: {
            contentBgColor: 'transparent'
        }
    };

    const defaults = {
        settingStyle: {
            bgType: bgTypes.COLOR,
            bgColor: system050.color,
            contentBgType: 1,
            contentBgColor: convertRGBtoRGBA('#fff', 0.5),
            buttonBgColor: '#ff004e',
            buttonTextColor: '#fff',
            titleColor: system900.color,
            ...defaultPopupColor,
            ...defaultReferralButton(false, true),
            ...defaultReferralShareCard(gameType)
        }
    };

    return _merge(_cloneDeep(defaults), config[gameType] || {});
};
